import { PageContent } from '@/components/layout/page-content'
import { PageHeader } from '@/components/layout/page-header'
import { PageLayout } from '@/components/layout/page-layout'
import { TableInfo } from '@/components/tables/table'
import type { Request } from '@/types/requests/request'
import { useChangeOfMajor } from './hooks/use-change-of-major'

export const ChangeOfMajorPage = () => {
  const {
    states: { data, isLoading },
    actions: { createTable }
  } = useChangeOfMajor()

  const tableConfig = createTable(data?.data)

  return (
    <PageLayout isLoading={isLoading} loadingText="Carregando Solicitações">
      <PageHeader title="Menu De Solicitações" breadcrumb />
      <PageContent>
        <TableInfo<Request>
          paginationData={data?.pagination}
          withFilters={true}
          tableConfig={tableConfig}
          isLoading={isLoading}
        />
      </PageContent>
    </PageLayout>
  )
}
